import predefinedPreviewTargets, {
  PredefinedCanvasPreviewTargetDeviceName,
  PredefinedCanvasPreviewTargetName,
} from '../predefinedPreviewTargets';
import { CanvasPreviewDeviceTarget, CanvasPreviewTarget } from '../types';

export default function getPredefinedPreviewTargetByName(
  sizeName: PredefinedCanvasPreviewTargetDeviceName,
): CanvasPreviewDeviceTarget;
export default function getPredefinedPreviewTargetByName(
  sizeName: PredefinedCanvasPreviewTargetName,
): CanvasPreviewTarget;
export default function getPredefinedPreviewTargetByName(sizeName: string): CanvasPreviewTarget | undefined;
export default function getPredefinedPreviewTargetByName(sizeName: string): CanvasPreviewTarget | undefined {
  const targets: Record<string, CanvasPreviewTarget | undefined> = predefinedPreviewTargets;
  return targets[sizeName];
}
